<template lang="pug">
div
  v-subheader(v-if="(label !== 'none') && (label !== '')").px-0 {{ label }}
  div.preview-media-list(:id="'lightgallery_'+id")
    template(v-for="item in localItems")
      a(v-if="item.type.includes('video')" data-poster="/static/icons/video_poster.png" :data-html="'#video_'+item.uuid" :data-download-url="item.url" :data-sub-html="subHtml(item)")
        img.preview-media-item(src="/static/icons/video_mime.png")
      a(v-else :href="item.optimizedUrl" data-html="'video_'+item.uuid" :data-download-url="item.url" :data-sub-html="subHtml(item)")
        img(:class="smallMobImg ? 'preview-small-media-item' : 'preview-media-item' " :src="item.thumbnailUrl")

  div.d-none
    div.d-none(v-for="(item, index) in localItems" :id="'video_'+item.uuid" v-if="item.type.includes('video')")
      video(class="lg-video-object lg-html5" controls preload="none")
        source(:src="item.url" type="video/mp4")
        | {{ $tf('mediaViewer.noSupport') }}
</template>

<script>
import 'lightgallery.js/dist/css/lightgallery.css'
import 'lightgallery.js'
import '@/components/utils/MediaViewer/lg-thumbnail/index'
import '@/components/utils/MediaViewer/lg-video/index'
import '@/components/utils/MediaViewer/lg-zoom/index'
import '@/components/utils/MediaViewer/lg-geolocation/index'
import minioAPI from '@/services/minio'

export default {
  name: 'ImageViewer',

  props: {
    id: {
      type: String,
      required: true,
    },
    smallMobImg: {
      type: Boolean,
      required: false,
      default: false,
    },
    label: {
      type: String,
      default: () => this.$tf('mediaViewer.label'),
    },
    meta: {
      type: Boolean,
      default: true,
    },
    items: {
      default: () => ([]),
      type: Array,
    },
  },

  data() {
    return {
      el: null,
      localItems: null,
    }
  },

  watch: {
    'items'(value) {
      this.localItems = value
      minioAPI.presignedGetObjectUrls(this.items).then((result) => {
        this.localItems = result.data
      })
    },
  },

  mounted() {
    this.localItems = this.items
    minioAPI.presignedGetObjectUrls(this.items).then((result) => {
      this.localItems = result.data
      this.el = document.getElementById(`lightgallery_${this.id}`)
      window.lightGallery(this.el, { closable: false })
    })
  },

  beforeDestroy() {
    window.lgData[this.el.getAttribute('lg-uid')].destroy(true)
  },

  methods: {
    subHtml(item) {
      if (this.meta) {
        return `<p>${this.$tf('mediaViewer.author')}: ${item.author}</p><p>${this.$tf('mediaViewer.uploadDate')}: ${this.$moment(item.uploadDate).format('YYYY-MM-DD HH:MM:SS')}</p>${item.note ? `<p>${this.$tf('mediaViewer.note')}: ${item.note}</p>` : ''}`
      }
      return null
    },
  },
}
</script>

<style lang="stylus">
.preview-media-list
  display flex
  flex-wrap wrap
  align-items center
  margin-top 10px
  a:hover
    .preview-media-item
      transform scale3d(1.1, 1.1, 1.1)
  .preview-media-item
    margin-right 15px
    margin-bottom 15px
    width 150px
    height 150px
    display inline-block
    background url('/static/icons/loading_spinner.gif') center no-repeat
    transition transform 0.15s ease 0s
  .preview-small-media-item
    width 40px
    height 40px
    display inline-block
    background url('/static/icons/loading_spinner.gif') center no-repeat
    transition transform 0.15s ease 0s
#lg-counter, .lg-sub-html
  font-family Roboto, sans-serif
.lg-actions .lg-next, .lg-actions .lg-prev
  color #fff !important
.lg-toolbar
  background-color rgba(0, 0, 0, 0.7)
.lg-geolocation:after
  content "\E80d"
.lg-map
  height 100%
  width 100%
  opacity 0
  z-index 0
  transition opacity 0.15s ease 0s
  transition-duration 150ms
.leaflet-left
  .leaflet-control
    margin-left 24px !important
.leaflet-top
  .leaflet-control
    margin-top 80px !important
.lg-no-geolocation
  width 60px
  height 60px
  position absolute
  top 50%
  left 50%
  margin -30px 0 0 -30px
  z-index 1079
  display none
  transition opacity 0.15s ease 0s
  transition-duration 150ms
</style>



// WEBPACK FOOTER //
// src/components/utils/MediaViewer/MediaViewer.vue